import NextLink from "next/link";
import { Card, Image, Flex, Link } from "@chakra-ui/react";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import type { PartnerCardProps } from "../PartnerCards.d";

export const PartnerCard = ({
  content,
  logoUrl,
  logoBackgroundColor,
  partnerLink = "",
}: Omit<PartnerCardProps, "_uid">) => (
  <Card maxW={96} variant="outline" borderColor="greyscale.300" borderRadius="lg" p={4}>
    <Link as={NextLink} href={partnerLink} passHref isExternal>
      <Flex bg={logoBackgroundColor} mb={10} height={32} borderRadius="lg" justify="center" align="center">
        <Image src={logoUrl} />
      </Flex>
    </Link>
    <RichtextAdapter content={content} customStyles={{ heading: { mb: 5 }, paragraph: { flex: 1 } }} />
  </Card>
);
